import BillNegotiation from './BillNegotiation'
import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import Bill from './Bill'

export default class BillInstallment extends Model {
    resourceName() {
        return 'bill-installment'
    }

    fields() {
        return ['id', 'installment', 'value', 'bill_id']
    }

    relationships() {
        return {
            bill: new Bill(),
            billNegotiation: new BillNegotiation(),
        }
    }

    computed() {
        return {
            formattedValue(period) {
                return i18n.n(period.value, 'currency')
            },
        }
    }
}
